import { EagleProfileHeader } from "./EagleProfileHeader";
export default EagleProfileHeader;
